module.exports = { "default": require("core-js/library/fn/array/map"), __esModule: true };